import { SiteInfo } from "../types";

export const fastQRGenerator: SiteInfo = {
  domainName: "fastqrgenerator.com",
  siteName: "QR Generator",
  siteTheme: "daikiri",
  siteEmail: "info@fastqrgenerator.com",
  siteWhiteLogo: "/svg/logo-white.svg",
  siteBlackLogo32: "/svg/logo32.svg",
  siteBlackLogo28: "/svg/logo28.svg",
  siteBlackLogoFooter: "/svg/logoFooter.svg",
  favicon: "/images/favicon-default.png"
};
